<template>
  <div v-if="isViewActive" ref="whole_page">

    <div class="vx-row mx-auto">
      <!-- Continue From -->
      <div class="vx-col w-full mobileView">
        <div class=" w-full">
          <ul style="margin-top: 3px;flex-wrap: wrap;">
            <div class="limit-width_fixed-scalable" style="text-align: left;">
              <li v-for="(course, index) in allModules.map(function(item) {return item.courseName }).filter(function(value, index, self) {return (self.indexOf(value) === index)})" :key="index" class="mb-4">
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="max-width: 80vw; word-break:break-word;">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_bg-color__blend bg-color">
                        <span><feather-icon class="pt-1" icon="BookOpenIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color "
                      type="filled"
                      color="">
                      {{ course }}
                    </vs-button>
                  </vx-input-group>
                </vx-card>

                <ul style="margin-top: 0.2rem;margin-bottom: 1.2rem;flex-wrap: wrap;">
                  <li v-for="(mod, modIndex) in allModules.filter(function(item){return (item.courseName == course) && (item.isMilestone === false)} )" :key="modIndex" class="mb-3">
                    <vx-card card-background="#11193f" class="glow-effect_dark limit-width_fixed-scalable card__no-padding">
                      <vx-input-group>
                        <template slot="prepend">
                          <div class="prepend-text glow-effect_dark" style="background-color: #41475E;border-radius: 5px 0 0 5px !important;">
                            <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
                          </div>
                        </template>

                        <vs-button
                          size="large"
                          class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                          style="border-radius:0 7px 7px 0; word-break: break-word; max-width:100vw;"
                          @click="goto(mod)">
                          {{ mod.moduleName }}
                        </vs-button>
                      </vx-input-group>
                    </vx-card>
                  </li>
                </ul>
              </li>
              <div v-if="allModules.length == 0 && moduleDataLoadComplete">
                <p style="color:white;font-weight:500;font-size:16px;padding-top:5px;text-align: center;">You have no modules yet...</p>
              </div>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  props: {
    isViewActive: {
      required: false,
    },
    allModules: {
      required: false
    },
    moduleDataLoadComplete:{
      required:false
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    isViewActiveLocal: {
      get() {
        return this.isViewActive;
      }
    }
  },
  methods: {
    goto(mod){

      if(mod.isNew){
        this.$emit('startNew', mod.moduleId, mod.taskDisplayId, mod.isLearningStyleB);
      }
      else
      {
        this.$emit('continueModuleSelected', mod);
      }
    },
  },
  mounted(){

  }
};
</script>

<style lang="scss">
  @media only screen and (max-width: 500px){
    .mobileView{
      margin: 0 auto;
      max-width: 90vw;
    }
    .header_button-item{
      max-width: 70vw !important;
    }
  }
</style>
